"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Synchronizer = void 0;
var Hls = require("hls.js");
var enum_1 = require("../enum");
var constants_1 = require("../constants/constants");
var calculateAccuracy_1 = require("../helper/calculateAccuracy");
var messageHandler_1 = require("../helper/messageHandler");
var config_1 = require("../config");
var Synchronizer = (function () {
    function Synchronizer(useProgramDateTime) {
        this.timerCount = 0;
        this.returnSpeedTimer = null;
        this.websocketConnection = null;
        this.streamOffset = 0;
        this.streamOffsetInitial = 0;
        this.synchronizeClient = null;
        this.frequency = 0;
        this.leader = false;
        this.syncAccuracyCallback = null;
        this.deltaCallback = null;
        this.speedChangeCallback = null;
        this.leaderCallback = null;
        this.chatUpdateCallback = null;
        this.clientListCallback = null;
        this.commandReceiveCallback = null;
        this.useProgramDateTime = false;
        this.rememberedPosition = 0;
        this.callbacks = [
            {
                type: enum_1.Callbacks.sync_accuracy_change,
                value: this.syncAccuracyCallback
            },
            {
                type: enum_1.Callbacks.delta_change,
                value: this.deltaCallback
            },
            {
                type: enum_1.Callbacks.speed_change,
                value: this.speedChangeCallback
            },
            {
                type: enum_1.Callbacks.leader_update,
                value: this.leaderCallback
            },
            {
                type: enum_1.Callbacks.chat_update,
                value: this.chatUpdateCallback
            },
            {
                type: enum_1.Callbacks.client_list_update,
                value: this.clientListCallback
            },
            {
                type: enum_1.Callbacks.receive_command,
                value: this.commandReceiveCallback
            }
        ];
        this.useProgramDateTime = useProgramDateTime;
    }
    Synchronizer.prototype.setSocketConnection = function (connection) {
        this.websocketConnection = connection;
    };
    Synchronizer.prototype.attachClient = function (client) {
        if (this.synchronizeClient) {
            return;
        }
        this.synchronizeClient = client;
    };
    Synchronizer.prototype.startSyncProcess = function () {
        var _a;
        if (this.synchronizeClient !== null) {
            (_a = this.websocketConnection) === null || _a === void 0 ? void 0 : _a.connectToSyncServer(this.synchronizeClient, this.createTimerSync.bind(this), this.handleMessage.bind(this));
        }
    };
    Synchronizer.prototype.stopSyncProcess = function () {
        var _a;
        if (this.timer) {
            clearInterval(this.timer);
        }
        if (this.timerDT) {
            clearInterval(this.timerDT);
        }
        (_a = this.websocketConnection) === null || _a === void 0 ? void 0 : _a.closeWebsocket();
    };
    Synchronizer.prototype.attachStreamOffset = function (offset) {
        this.streamOffset = offset;
    };
    Synchronizer.prototype.getStreamOffset = function () {
        return this.streamOffset;
    };
    Synchronizer.prototype.getGroupClients = function () {
        var _a;
        (_a = this.websocketConnection) === null || _a === void 0 ? void 0 : _a.getClientList();
    };
    Synchronizer.prototype.createTimerSync = function (data) {
        var _this = this;
        this.frequency = data.data.seconds * 1000;
        if (this.synchronizeClient !== null) {
            if (this.useProgramDateTime) {
                this.timerDT = setInterval(function () { return _this.sendCurrentPositionDT(_this.synchronizeClient); }, this.frequency);
                if (this.timer)
                    clearInterval(this.timer);
            }
            else {
                this.timer = setInterval(function () { return _this.sendCurrentPosition(_this.synchronizeClient); }, this.frequency);
                if (this.timerDT)
                    clearInterval(this.timerDT);
            }
        }
    };
    Synchronizer.prototype.sendCurrentPosition = function (client) {
        var _a;
        if (this.synchronizeClient && this.synchronizeClient.isPlaying()) {
            (_a = this.websocketConnection) === null || _a === void 0 ? void 0 : _a.sendClientPosition(client, this.streamOffset);
        }
    };
    Synchronizer.prototype.sendCurrentPositionDT = function (client) {
        var _a;
        if (this.synchronizeClient && this.synchronizeClient.isPlaying()) {
            (_a = this.websocketConnection) === null || _a === void 0 ? void 0 : _a.sendClientPositionDT(client, this.streamOffset, this.rememberedPosition);
        }
    };
    Synchronizer.prototype.setRememberedPosition = function (position) {
        this.rememberedPosition = position;
    };
    Synchronizer.prototype.syncPlay = function () {
        if (this.websocketConnection) {
            this.websocketConnection.groupPlay();
        }
    };
    Synchronizer.prototype.syncPause = function () {
        if (this.websocketConnection) {
            this.websocketConnection.groupPause();
        }
    };
    Synchronizer.prototype.muteGroup = function () {
        if (this.websocketConnection) {
            this.websocketConnection.muteGroup();
        }
    };
    Synchronizer.prototype.sendGroupMessage = function (message) {
        if (this.websocketConnection) {
            this.websocketConnection.sendMessageToGroup(message);
        }
    };
    Synchronizer.prototype.sendEventToGroup = function (payload) {
        if (this.websocketConnection) {
            this.websocketConnection.sendEventToGroup(payload);
        }
    };
    Synchronizer.prototype.changeGroupVolume = function (volume) {
        if (this.websocketConnection) {
            this.websocketConnection.changeVolume(volume);
        }
    };
    Synchronizer.prototype.getSyncClient = function () {
        if (this.synchronizeClient) {
            return this.synchronizeClient;
        }
    };
    Synchronizer.prototype.attachCallback = function (callback, type) {
        var handler = this.callbacks.filter(function (handlerItem) { return handlerItem.type === type; })[0];
        handler.value = callback;
    };
    Synchronizer.prototype.callCallback = function (type, argCallback) {
        var handler = this.callbacks.filter(function (handlerItem) { return handlerItem.type === type; })[0];
        if (handler.value !== null) {
            handler.value.apply(handler, argCallback);
        }
    };
    Synchronizer.prototype.initHls = function (client, playerType) {
        var _this = this;
        var handler = this.useProgramDateTime
            ? {
                callback: function (event, eventData) {
                    if (_this.useProgramDateTime) {
                        _this.attachStreamOffset(eventData.frag.programDateTime);
                        _this.setRememberedPosition(client.getCurrentPosition());
                    }
                },
                event: Hls.Events.FRAG_CHANGED
            }
            : {
                callback: function (event, eventData) {
                    if (eventData.initPTS > 0) {
                        var streamOffset = (Math.abs(eventData.initPTS) / constants_1.defaultPTSFrequency) * 1000;
                        _this.attachStreamOffset(Math.floor(streamOffset));
                    }
                },
                event: Hls.Events.INIT_PTS_FOUND
            };
        if (playerType === enum_1.PlayerType.html) {
            if (Hls.isSupported()) {
                var video = document.getElementById(client.getPlayerId());
                var videoUrl = client.getVideoUrl();
                video.src = videoUrl;
                var hls = new Hls({});
                hls.loadSource(videoUrl);
                hls.attachMedia(video);
                hls.on(handler.event, handler.callback);
                hls.on(Hls.Events.INIT_PTS_FOUND, function (event, eventData) {
                    if (eventData.initPTS > 0) {
                        var streamOffset = (Math.abs(eventData.initPTS) / constants_1.defaultPTSFrequency) * 1000;
                        _this.streamOffsetInitial = Math.floor(streamOffset);
                    }
                });
                if (this.useProgramDateTime) {
                    hls.on(Hls.Events.FRAG_PARSING_INIT_SEGMENT, function (event, eventData) {
                        if (!eventData.frag.programDateTime) {
                            _this.useProgramDateTime = false;
                            console.log('initial stream ', _this.streamOffsetInitial);
                            _this.attachStreamOffset(_this.streamOffsetInitial);
                            console.warn('[SyncSdk]: Stream fragment is not contain EXT-X-PROGRAM-DATE-TIME. Look like your HLS stream is not live.');
                        }
                    });
                }
            }
        }
        if (playerType === enum_1.PlayerType.nexplayer) {
            var nextPlayerInstance = client.getPlayerInstance();
            nextPlayerInstance === null || nextPlayerInstance === void 0 ? void 0 : nextPlayerInstance.player_.nexplayer_.hls_.on(handler.event, handler.callback);
            nextPlayerInstance === null || nextPlayerInstance === void 0 ? void 0 : nextPlayerInstance.player_.nexplayer_.hls_.on(Hls.Events.INIT_PTS_FOUND, function (event, eventData) {
                if (eventData.initPTS > 0) {
                    var streamOffset = (Math.abs(eventData.initPTS) / constants_1.defaultPTSFrequency) * 1000;
                    _this.streamOffsetInitial = Math.floor(streamOffset);
                }
            });
            if (this.useProgramDateTime) {
                nextPlayerInstance === null || nextPlayerInstance === void 0 ? void 0 : nextPlayerInstance.player_.nexplayer_.hls_.on(Hls.Events.FRAG_PARSING_INIT_SEGMENT, function (event, eventData) {
                    if (!eventData.frag.programDateTime) {
                        _this.useProgramDateTime = false;
                        _this.attachStreamOffset(_this.streamOffsetInitial);
                        console.warn('[SyncSdk]: Stream fragment is not contain EXT-X-PROGRAM-DATE-TIME. Look like your HLS stream is not live.');
                    }
                });
            }
        }
    };
    Synchronizer.prototype.handleMessage = function (data, ownMessage) {
        var _this = this;
        var _a, _b, _c;
        this.timerCount = 0;
        var result = null;
        var handler = messageHandler_1.receiveMessages[data.type];
        if (handler) {
            var handleData = {
                data: data,
                serverTimeDelay: (_a = this.websocketConnection) === null || _a === void 0 ? void 0 : _a.serverTimeDelay,
                streamOffset: this.streamOffset
            };
            if (data.type === enum_1.IncomeMessage.synchronize) {
                if (this.returnSpeedTimer) {
                    clearTimeout(this.returnSpeedTimer);
                }
                this.returnSpeedTimer = setTimeout(function () {
                    var _a;
                    (_a = _this.synchronizeClient) === null || _a === void 0 ? void 0 : _a.changePlaybackRate(1);
                }, config_1.default.maxDelta);
                result = handler({
                    callback: this.callCallback.bind(this),
                    client: this.synchronizeClient,
                    message: handleData,
                    ownMessage: ownMessage,
                    rememberedPosition: this.useProgramDateTime ? this.rememberedPosition : false
                });
                this.returnSpeedTimer = setTimeout(function () {
                    var _a;
                    (_a = _this.synchronizeClient) === null || _a === void 0 ? void 0 : _a.changePlaybackRate(1);
                }, config_1.default.maxDelta);
            }
            else if (data.type === enum_1.IncomeMessage.sync_progress) {
                result = handler({
                    callback: this.callCallback.bind(this),
                    client: this.synchronizeClient,
                    message: handleData,
                    ownMessage: ownMessage,
                    rememberedPosition: this.useProgramDateTime ? this.rememberedPosition : false
                });
            }
            else {
                handler({
                    callback: this.callCallback.bind(this),
                    client: this.synchronizeClient,
                    message: data,
                    ownMessage: ownMessage,
                    rememberedPosition: null
                });
                return;
            }
        }
        if (result !== null && result.delta) {
            this.callCallback(enum_1.Callbacks.delta_change, [result.delta]);
        }
        if (result !== null && result.delta) {
            var accuracy = calculateAccuracy_1.default(result.delta);
            this.callCallback(enum_1.Callbacks.sync_accuracy_change, [accuracy]);
        }
        if ((_b = data.data) === null || _b === void 0 ? void 0 : _b.leader) {
            this.callCallback(enum_1.Callbacks.leader_update, [((_c = data.data) === null || _c === void 0 ? void 0 : _c.leader) || false]);
        }
    };
    return Synchronizer;
}());
exports.Synchronizer = Synchronizer;
//# sourceMappingURL=Synchronizer.js.map